import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import { green } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  checkboxLabel: {
    fontSize: "14px"
  }
}));

const RadioFilters = (props) => {
  const { filters, onChangeCriteria, criteriaSelected } = props;
  const classes = useStyles();

  const handleChange = (event) => {
    onChangeCriteria(+event.target.value);
  };

  return (
    <FormControl>
      <RadioGroup
        row
        name="row-radio-buttons-group"
        value={criteriaSelected}
        onChange={handleChange}
      >
        {filters?.map(function (option, index) {
          return (
            <FormControlLabel
              key={index}
              classes={{
                label: classes.checkboxLabel
              }}
              control={
                <Radio
                  sx={{
                    color: green[800],
                    "&.Mui-checked": {
                      color: green[600],
                    },
                  }}
                />
              }
              label={option.name}
              value={index}
              disabled={option.disable}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioFilters;
